<template>
<div>

<section v-if="localSelectedEvent">
  
  <!-- ====== EDITVIEW <br> -->
  <!-- {{selectedEvent}} -->
  <!-- {{localSelectedEvent}} -->



  <section class="section">

    <b-field label="Tag" label-position="on-border">
        <b-input type="text" placeholder="Tag"  
            v-model="localSelectedEvent.etag"
            maxlength="30">
        </b-input>
    </b-field>

    <b-field label="Summary" label-position="on-border">
        <b-input type="text" placeholder="Summary"  
            v-model="localSelectedEvent.summary"
            maxlength="90">
        </b-input>
    </b-field>

    <b-field label="Description" label-position="on-border">
        <b-input type="textarea" placeholder="Description"  
            v-model="localSelectedEvent.description"
            maxlength="300">
        </b-input>
    </b-field>

    <!-- DATE / TIME -->
    <h2><b>Start Date/Time</b></h2>
    <b-field grouped expanded >

      
        <b-datepicker v-model="localSelectedEvent.start.date" >
        </b-datepicker>

        <b-timepicker v-model="localSelectedEvent.start.dateTime"
            placeholder="Type or select a start time..."
            icon="clock"
            editable>
        </b-timepicker>
    </b-field>


    <h2><b>End Date/Time</b></h2>
    <b-field grouped expanded >

      <b-datepicker v-model="localSelectedEvent.end.date" >
      </b-datepicker>

      <!-- <b-field label="Select timepicker"> -->
        <b-timepicker v-model="localSelectedEvent.end.dateTime"
            placeholder="Type or select a end time..."
            icon="clock"
            editable>
        </b-timepicker>
    <!-- </b-field> -->

    </b-field>

  


    <b-field label="Status" label-position="on-border">
      <b-select placeholder="Select Status" expanded v-model="localSelectedEvent.status" 
            @keypress.prevent icon="arrow-circle-right" icon-pack="fas">
        <option value="">Select Status</option>
        <option value="done">Done</option>
        <option value="open">Open</option>
        <option value="cancelled">Cancelled</option>
      </b-select>
    </b-field>

    <b-field label="Type" label-position="on-border">
      <b-select placeholder="Select Type" expanded v-model="localSelectedEvent.type" 
            @keypress.prevent icon="arrow-circle-right" icon-pack="fas">
        <option value="">Select Type</option>
        <option value="is-link">Link</option>
        <option value="is-info">Info</option>
        <option value="is-warning">Warning</option>
        <option value="is-success">Success</option>
      </b-select>
    </b-field>

    <!-- {{account}} -->
    <!-- {{account.members}} -->

    <b-field>
      <!-- <select v-model="selectedContact" @change.prevent="putSelectedContact(selected)"> -->
      <b-select placeholder="Select Contact" expanded  v-model="selected" @input="onSelectChange"
              :loading="!true"
              @keypress.prevent icon="arrow-circle-right" icon-pack="fas">
        <option disabled value="">Select an Contact</option>
        <!-- <option value="Mike Cool">Mike Cool</option>
        <option value="Hanna Smart">Hanna Smart</option>
        <option value="Mikisko Bub">Mikisko Bub</option> -->

        <option v-for="member in getMembers"
            :value="member" :key="member.id">
          {{ member.displayName }} 
        </option>
        <!-- <option v-for="member in account.members"
                :value="member" :key="member.id">
          {{ memeber.firstname }} {{ memeber.name }} 
        </option> -->
      </b-select>
    
      <b-field>
        <div class="control">
            <b-switch v-model="isOrgananizer">Organizer </b-switch>
        </div>
      </b-field>

      <b-button
        :disabled="!selected || selected.length === 0"
        @click="onAddAttendee();"
        icon-left="fas fa-angle-double-right"
        type="is-primary">
        Add
      </b-button>

    </b-field>


  <!-- {{localSelectedEvent.attendees}} -->

  <b-field grouped group-multiline>
    <div v-for="att in localSelectedEvent.attendees" :key="att.id" @dblclick="onDeleteAtt(att)">
      <b-field style="margin:0.2em; padding:0.2em; min-width: 3em; background: green; color: white;">
        <b-button 
          @click="onDeleteAtt(att);"
          icon-left="fas fa-times"
          type="is-light">
        </b-button>

        <div style="margin:0.2em; padding:0.2em; min-width: 3em; background: green; color: white;">
          {{att.displayName}}
        </div>
      </b-field>
    </div>
  
  </b-field>

  <!-- == SAVE == -->
  <b-field>
    <div class="control">
        <b-switch v-model="isGoogleSync">Sync Event with Google Calendar</b-switch>
    </div>
  </b-field>
  <b-field>
    <div class="control">
        <b-switch v-model="isReminder">Create Reminder / Activity</b-switch>
    </div>
  </b-field>
  <div style="margin-top:10px;">
      <a class="button is-light"  @click="saveEvent">
        <div>  
          <i class="fas fa-save" style="color: green; margin-right: 1em; font-size:1.8em;" aria-hidden="true"></i>
        </div>
        SAVE
      </a>
    </div> 


    <!-- ======= EDIT ======= -->




  </section>
</section>
</div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { ActivityStruct } from '@/utils/structs'
  // const thisMonth = new Date().getMonth()
  // const thisYear = new Date().getFullYear()
  import * as moment from 'moment';


  export default {
    name: 'EditEvent',
    data() {
      return  {
      
        // localSelectedEvent: {},
        selected: null,
        isOrgananizer: false,
        isGoogleSync: true,
        isReminder: true,
      }
    },
  props: {
    // msg: String,
    // pickeddate: String
    // 'localSelectedContact'
    localSelectedEvent: null
  },
  created () {
    
  },
  filters: {
      /**
      * Filter to truncate string, accepts a length parameter
      */
      truncate(value, length) {
          return value.length > length
              ? value.substr(0, length) + '...'
              : value
      }
    },
  computed: {
    // ...mapState(['user', 'account']),
    ...mapGetters(['getAccount', 'getMembers']), // 'allEvents', 'selectedEvent'
    indicators() {
        return this.bars ? 'bars' : 'dots'
    },
    
  },
  methods: {
    ...mapActions(['updateEvent', 'putSelectedEvent','addNewActivity']),
    createLocalAllEvents () {
      console.log('create localAllEvents') //make json copy and set Date() type
      let tmpevents = []
      for (let event of this.allEvents) {
        let tmpevent = JSON.parse(JSON.stringify(event))
        tmpevent["date"] = new Date(tmpevent.start.date) // .. needed for the datepicker component (set here instead of event datamodel)
        tmpevents.push(tmpevent)
      }
      return tmpevents
    },
    setFilteredEvents () {
      // console.log('start filtering ..')
      // const localAllEvents = JSON.parse(JSON.stringify(this.allEvents))
      if (!this.isRange) {
        this.localFilteredEvents = this.localAllEvents.filter(event => event.date.getTime() === this.pickeddate.getTime())
      } else {
        this.localFilteredEvents = this.localAllEvents.filter(event => event.date >= this.pickeddate[0] && event.date <= this.pickeddate[1])
      } 
    },
    toggle(row) {
        this.$refs.table.toggleDetails(row)
    },
    onSelectChange() {
      // let tmpatt = {
      //   // id: this.selected.id, 
      //   // displayName: this.selected.firstname+' '+this.selected.name,
      //   // organizer: false
      //   
      // }
      // this.localSelectedEvent.attendees.push(tmpatt)
    },
    onAddAttendee() {
      console.log("add")
      this.localSelectedEvent.attendees.push(
        // {id: Date.now().toString(),
        {
          id: this.selected.id,
          displayName: this.selected.displayName,
          organanizer: this.isOrgananizer
        })

      this.selected = null
      this.isOrgananizer = false
    },
    onDeleteAtt(delatt) {
      const index = this.localSelectedEvent.attendees.findIndex(att => att.id === delatt.id)
            if (index !== -1) {
                this.localSelectedEvent.attendees.splice(index, 1)
            }
    },
    saveEvent() {
      this.updateEvent(this.localSelectedEvent)
      this.putSelectedEvent(this.localSelectedEvent)

      if (this.isReminder) {
        var tmpdate = new Date(this.localSelectedEvent.start.date)
        let tmpact = JSON.parse(JSON.stringify(ActivityStruct))


        // console.log("ACCOUNT > " + JSON.stringify(this.getAccount))
        tmpdate.setDate(tmpdate.getDate() - this.getAccount.alerttime)
        // console.log( tmpdate )
        tmpact.due.date = new Date()
        
        tmpact.due.date = tmpdate // subtract days alerttime
        
        tmpact.due.dateTime = new Date(this.localSelectedEvent.start.dateTime)
        tmpact.header = "Reminder"
        tmpact.message = moment(this.localSelectedEvent.start.date).format("DD/MM/YYYY") + " | " + moment(this.localSelectedEvent.start.dateTime).format("HH:mm") + " \n" + this.localSelectedEvent.etag + "\n" + this.localSelectedEvent.summary + "\n" + this.localSelectedEvent.description
        tmpact.eventid = this.localSelectedEvent
        tmpact.channel = 'reminder'
        this.addNewActivity(tmpact)
        console.log("reminder added > "+ JSON.stringify(tmpact))
      }
    },


    // .. DATEPICKER COMPONENT NEED DATE from type new Date() / not string !!! this is done now in this.createLocalAllEvents() 
    // createEventsToShow () {
    //   for (let event of this.localAllEvents) {
    //     this.eventsToShow.push({date: new Date(event["date"]), type: event["type"] })
    //   }
    // },
  },
  watch: {
    allEvents () {
        // this.localAllEvents = JSON.parse(JSON.stringify(newValue))
        this.localAllEvents = this.createLocalAllEvents()
        // this.createEventsToShow()
        // this.setFilteredEvents()
        // console.log("watch -> allEvents @ Calendar.vue triggered")
    },

    localSelectedEvent () {
      this.selected = null
    }
    // selectedEvent () {
    //   // console.log("watch -> selectedEvent @ EditEvent.vue triggered")
    // }
  }
}



// function mydateFormatter (date: Date):String {
//   let options = { year: 'numeric', month: 'short', day: 'numeric' };
//   return date.toLocaleDateString('de', options);
// }

</script>




<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
